const IS_DEV = false;
export const API_KEY = IS_DEV
  ? "eea1bbda1f8835b27dd821a65c658ddb"
  : "d45028a4c5774ccbbbc01ad59162cd53";

  export const API_URL = IS_DEV
  ? "https://dev.powerlego.com/ApiGateway/"
  : "https://www.powerlego.com/ApiGateway/";